import {
  isFinancialUploadDocumentType,
  resolveDocumentUploadErrorMessage,
} from "helpers/financialUploadValidation";

export type AssociateDocumentUploadError = {
  status?: number | string;
  data?: unknown;
  message?: string;
};

const extractUploadErrorMessage = (error: AssociateDocumentUploadError): string => {
  if (typeof error.message === "string" && error.message.trim()) {
    return error.message;
  }

  const responseData = error.data;
  if (responseData && typeof responseData === "object") {
    const payload = responseData as { message?: string; detail?: string };
    if (typeof payload.message === "string" && payload.message.trim()) {
      return payload.message;
    }
    if (typeof payload.detail === "string" && payload.detail.trim()) {
      return payload.detail;
    }
  }

  return "Something went wrong while uploading document.";
};

export const transformAssociateDocumentUploadError = (
  error: AssociateDocumentUploadError,
  documentType?: string | null,
): AssociateDocumentUploadError => {
  const rawMessage = extractUploadErrorMessage(error);
  const isFinancialDocumentType = isFinancialUploadDocumentType(documentType);

  const resolvedMessage = resolveDocumentUploadErrorMessage({
    errorMessage: rawMessage,
    duplicateDocumentMessage: rawMessage,
    isFinancialDocumentType,
  });

  return {
    ...error,
    message: resolvedMessage,
  };
};
